import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { CopiiService } from './copii.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { DialogService } from 'src/app/services/dialog.service';
import { AddCopiiComponent } from './add-copii/add-copii.component';
import { EditCopiiComponent } from './edit-copii/edit-copii.component';

interface UploadedPdf {
    name: string;
    url: string;
    uploadDate: string;
    size?: number;
    chunks?: any[];
}


@Component({
    selector: 'app-copii',
    templateUrl: './copii.component.html',
    styleUrls: ['./copii.component.scss']
})
export class CopiiComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        scopcf: -1,
        fara_lista_patrimoniu: -1,
        confirmed: -1,
        numar_solicitare: '',
        cnp_cui: '',
        rol_id: '',
        full_name: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            scopcf: new FormControl(-1),
            fara_lista_patrimoniu: new FormControl(-1),
            confirmed: new FormControl(-1),
            numar_solicitare: new FormControl(''),
            cnp_cui: new FormControl(''),
            rol_id: new FormControl(''),
            full_name: new FormControl(''),
        });
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.dgaspc.activitati.copii.getCopiiDT;

    mockData = {
        errors: false,
        data: {
            draw: 1,
            recordsTotal: 5,
            recordsFiltered: 5,
            data: [
                {
                    id: 1,
                    cerere_info: "Ion Popescu",
                    name: "1234567890123",
                    identifier: "București, Sector 1",
                    document_info: "Maria Popescu, Gheorghe Popescu",
                    status: "ion.popescu@email.com, 0721123456",
                    created_at: "2025-03-13 17:24:01",
                    uploaded_pdfs: [
                        {
                            name: "20MB-TESTFILE.ORG.pdf",
                            url: "/assets/pdfs/20MB-TESTFILE.ORG.pdf",
                            uploadDate: "2025-03-15",
                            //   size: 2048576 
                        },
                        {
                            name: "50mb.pdf",
                            url: "/assets/pdfs/50mb.pdf",
                            uploadDate: "2025-03-16",
                            //   size: 1536000 
                        }
                    ]
                },
                {
                    id: 2,
                    cerere_info: "Ana Ionescu",
                    name: "2345678901234",
                    identifier: "Cluj-Napoca",
                    document_info: "Elena Ionescu, Mihai Ionescu",
                    status: "ana.ionescu@email.com, 0722234567",
                    created_at: "2025-03-13 17:30:43",
                    uploaded_pdfs: []
                },
                {
                    id: 3,
                    cerere_info: "Mihai Georgescu",
                    name: "3456789012345",
                    identifier: "Timișoara",
                    document_info: "Carmen Georgescu, Adrian Georgescu",
                    status: "mihai.georgescu@email.com, 0723345678",
                    created_at: "2025-03-13 17:32:49",
                    uploaded_pdfs: [
                        {
                            name: "30MB-TESTFILE.ORG.pdf",
                            url: "/assets/pdfs/30MB-TESTFILE.ORG.pdf",
                            uploadDate: "2025-03-17",
                            //   size: 3072000 
                        }
                    ]
                },
                {
                    id: 4,
                    cerere_info: "Diana Marinescu",
                    name: "4567890123456",
                    identifier: "Iași",
                    document_info: "Rodica Marinescu, Vasile Marinescu",
                    status: "diana.marinescu@email.com, 0724456789",
                    created_at: "2025-03-13 17:34:54",
                    uploaded_pdfs: []
                },
                {
                    id: 6,
                    cerere_info: "Test User",
                    name: "5678901234567",
                    identifier: "Constanța",
                    document_info: "Test Parent 1, Test Parent 2",
                    status: "test@email.com, 0725567890",
                    created_at: "2025-03-17 15:37:51",
                    uploaded_pdfs: []
                }
            ]
        },
        status_code: 200
    };

    constructor(
        private http: HttpClient,
        private copiiService: CopiiService,
        public permissionsService: PermissionsService,
        private dialog: MatDialog,
        private dialogService: DialogService
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.buildSearchParamsForm();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    formatDate(dateString: string): string {
        if (!dateString) return '';

        const date = new Date(dateString);

        // Check if date is valid
        if (isNaN(date.getTime())) return '';

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                Object.assign(dataTablesParameters, { ...this.searchParamsForm.value });

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Nume și prenume',
                    data: 'full_name',
                    orderable: false,
                },
                {
                    title: 'Data nașterii',
                    data: 'birth_date',
                    orderable: false,
                    render: (data: string) => {
                        return this.formatDate(data);
                    },
                },
                {
                    title: 'Locație',
                    data: 'personal_data',
                    orderable: false,
                    render: (data: any) => {
                        return data.locatie;
                    },
                },
                {
                    title: 'Părinți',
                    data: 'personal_data',
                    orderable: false,
                    render: (data: any) => {
                        return data.parintii;
                    },
                },
                {
                    title: 'Date de contact',
                    data: 'contact_info',
                    orderable: false,
                    render: (data: any) => {
                        return data.email + ', ' + data.telefon;
                    },
                },
                {
                    title: 'Data actualizării / Ultima actualizare',
                    data: 'updated_at',
                    render: (data: string) => {
                        return this.formatDate(data);
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: () => {
                        return `
                            <div class="d-flex align-center justify-content-left">
                                <button class="action-btn edit ms-1">
                                    <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                                </button>
                                <button class="action-btn delete ms-1">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                                </button>
                            </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.copii.update'
                    //     )
                    // ) {
                    //     editIcon.style.display = 'none';
                    // }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.copii.delete'
                    //     )
                    // ) {
                    //     deleteIcon.style.display = 'none';
                    // }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteCopil(id);
                    });
                }

                return row;
            },
        };
    }

    // renderDT() {
    //     this.isLoading = true;
    //     this.dtOptions = {
    //         serverSide: false, // Changed to false since we're using local data
    //         searching: false,
    //         responsive: true,
    //         data: this.mockData.data.data, // Use local data instead of ajax
    //         language: environment.config.romanianLanguageDataTable,
    //         columns: [
    //             {
    //                 title: 'ID',
    //                 data: 'id',
    //             },
    //             {
    //                 title: 'Nume și prenume',
    //                 data: 'cerere_info',
    //                 orderable: false,
    //             },
    //             {
    //                 title: 'CNP',
    //                 data: 'name',
    //                 orderable: false,
    //             },
    //             {
    //                 title: 'Locație',
    //                 data: 'identifier',
    //                 orderable: false,
    //             },
    //             {
    //                 title: 'Părinți',
    //                 data: 'document_info',
    //                 orderable: false,
    //             },
    //             {
    //                 title: 'Date de contact',
    //                 data: 'status',
    //                 orderable: false,
    //             },
    //             {
    //                 title: 'Data actualizării / Ultima actualizare',
    //                 data: 'created_at',
    //             },
    //             {
    //                 title: 'Acțiuni',
    //                 data: null,
    //                 orderable: false,
    //                 className: 'all',
    //                 render: () => {
    //                     return `
    //                     <div class="d-flex align-center justify-content-left">
    //                         <button class="action-btn edit ms-1">
    //                             <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
    //                         </button>
    //                         <button class="action-btn delete ms-1">
    //                             <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
    //                         </button>
    //                     </div>
    //                 `;
    //                 },
    //             },
    //         ],
    //         rowCallback: (row: Node, data: any[] | any) => {
    //             const lastTd = (row as HTMLElement).querySelector('td:last-child');
    //             const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
    //             const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

    //             if (editIcon) {
    //                 // if (
    //                 //     !this.permissionsService.hasPermission(
    //                 //         'dgaspc-module.copii.update'
    //                 //     )
    //                 // ) {
    //                 //     editIcon.style.display = 'none';
    //                 // }
    //                 editIcon.addEventListener('click', () => {
    //                     this.openEditDialog(data);
    //                 });
    //             }

    //             if (deleteIcon) {
    //                 // if (
    //                 //     !this.permissionsService.hasPermission(
    //                 //         'dgaspc-module.copii.delete'
    //                 //     )
    //                 // ) {
    //                 //     deleteIcon.style.display = 'none';
    //                 // }
    //                 deleteIcon.addEventListener('click', () => {
    //                     const { id } = data;
    //                     this.deleteCopil(id);
    //                 });
    //             }

    //             return row;
    //         },
    //     };
    //     this.isLoading = false; // Set loading to false since we're not making HTTP calls
    // }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });

        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddCopiiComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Copil adăugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditCopiiComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Copil actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteCopil(id: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.copiiService.deleteCopil(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: 'Șters!',
                        text: 'Copil șters cu succes.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                });
            }
        });
    }
}